import {Component, Input, OnInit} from '@angular/core';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
    selector: 'frog-async-spinner',
    templateUrl: './async-spinner.component.html',
    styleUrls: ['./async-spinner.component.scss'],
    imports: [MatProgressSpinner],
})
export class AsyncSpinnerComponent implements OnInit {
    @Input() text: string = 'Loading...';

    constructor() {}

    ngOnInit(): void {}
}
